import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=e1b70e02&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports